import { CONNECTION_STATUS } from "../../types";

export const CONNECTION_ONLINE = "online";
export const CONNECTION_OFFLINE = "offline";
export interface ConnectionStatusAction {
  type: CONNECTION_STATUS;
}
